import React from 'react';
import { Helmet } from 'react-helmet';
import useToggle from '../../../Hooks/useToggle';
import pageBanner from '../../../assets/images/backoffice-banner.webp';
import backofficeImg1 from '../../../assets/images/backoffice-dashboard.webp';
import backofficeImg2 from '../../../assets/images/backoffice-invoices.webp';
import BackToTop from '../../BackToTop';
import FooterHomeThree from '../../Footer/FooterHomeThree';
import HeaderNews from '../../Header/HeaderNews';
import HeroNews from '../../Header/HeroNews';
import Drawer from '../../Mobile/Drawer';
import PreviewSlider from '../../PreviewSlider';
import ServicesAbout from './ServicesAbout';
import ShowCase from './ShowCase';

function Backoffice() {
    const [drawer, drawerAction] = useToggle(false);
    return (
        <>
            <Helmet>
                <meta
                    name="description"
                    content="Invoices and payments, customer statements, supplier bills, payroll and full accounts with profit and loss and balance sheet. Made in Rwanda."
                />
                <title>Accounting, Invoicing & Payroll Software | OTO by Kapp</title>
            </Helmet>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderNews action={drawerAction.toggle} />
            <main>
                <HeroNews
                    title="Backoffice"
                    breadcrumb={[
                        { link: '/', title: 'Home' },
                        { link: '/apps', title: 'Apps' },
                        { link: '/apps/frontdesk', title: 'Frontdesk' },
                    ]}
                />

                <div
                    className="container pt-90 pb-90"
                    style={{ fontSize: '18px', lineHeight: '29px' }}
                >
                    <h2 className="as-h3 mb-4">Backoffice Software</h2>
                    <p className="mb-3">
                        Are you tired of managing your business's invoices, cash books and other
                        financial operations manually, spending countless hours on paperwork and
                        data entry? Our backoffice software can help simplify and streamline your
                        business operations, allowing you to focus on growing your business.
                    </p>
                    <p>
                        Our backoffice app can help you manage invoices, proforma, cash books and
                        much more.
                    </p>

                    <img
                        loading="lazy"
                        className="page-banner-img mt-4"
                        src={pageBanner}
                        alt="OTO Inventory Software"
                    />
                </div>

                <ServicesAbout />

                <ShowCase />

                <div className="container">
                    <PreviewSlider
                        images={[
                            { url: backofficeImg1, alt: 'Backoffice' },
                            { url: backofficeImg2, alt: 'Backoffice' },
                        ]}
                    />
                </div>
                <div className="container pt-60 pb-80 text-center">
                    <div className="mx-auto" style={{ maxWidth: '800px' }}>
                        <p className="mb-3">
                            Don't waste another minute on manual data entry and accounting. Contact
                            us today to learn more about how our backoffice software can help
                            streamline your financial operations and drive growth.
                        </p>
                    </div>
                </div>
            </main>
            <FooterHomeThree className="appie-footer-about-area" />
            <BackToTop />
        </>
    );
}

export default Backoffice;
